"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingContractInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_collection_1 = require("@dzambalaorg/types-collection");
const types_1 = require("@framework/types");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const StakingContractInput = () => {
    const form = (0, react_hook_form_1.useFormContext)();
    const merchantId = (0, react_hook_form_1.useWatch)({ name: "merchantId" });
    (0, react_hooks_1.useDidMountEffect)(() => {
        form.setValue("contractId", types_collection_1.InputType.awaited);
    }, [merchantId]);
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "contractId", controller: "contracts", fetchData: {
            contractModule: [types_1.ModuleType.STAKING],
            merchantId,
        }, autoSelect: true, disableClear: true }));
};
exports.StakingContractInput = StakingContractInput;
//# sourceMappingURL=index.js.map